import { Link } from '@cambridgeassessment/cambridge-ui';
import { Box, Typography } from '@material-ui/core';
import SadFace from '@material-ui/icons/SentimentDissatisfiedRounded';
import * as React from 'react';

const ErrorMessage: React.FC = () => {
  return (
    <Box display="flex" justifyContent="center" width="100%">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        maxWidth="400px"
        marginY={6}
      >
        <SadFace style={{ width: 68, height: 68, fill: '#9E9E9E' }} />
        <Box mt={3}>
          <Typography variant="h2" align="center">
            Something went wrong...
          </Typography>
        </Box>
        <Box mt={3}>
          <Typography variant="body1" align="center">
            Try refreshing the page
          </Typography>
        </Box>
        <Box mt={3}>
          <Typography variant="body1" align="center">
            If you&apos;ve tried refreshing the page and it still doesn&apos;t
            work,{' '}
            <Link
              href="mailto:cambridge-identity@cambridgeassessment.org.uk"
              underline="always"
            >
              contact us
            </Link>
            .
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ErrorMessage;
